export enum ONBOARD_FLOW_FEATURE {
  BUILD_HEALTHY_HABITS = 'build-healthy-habits',
  STAY_FOCUSED_AT_WORK = 'stay-focused-at-work'
}

export enum ONBOARD_FLOW_STEP {
  DATA_PRIVACY = 'data-privacy',
  FEATURE_SELECTION = 'feature-selection',
  HABIT_DESIGN_SESSION = 'habit-design-session',
  GOALS_SELECTION = 'goals-selection',
  CHOOSE_ROUTINE = 'choose-routine',
  ROUTINE_HABITS = 'routine-habits',
  TIME_SETUP = 'time-setup',
  BEARSONA_PROFILE = 'bearsona-porfile',
  DOWNLOAD_APPS = 'download-apps'
}

export enum ONBOARD_FLOW_ROUTINE {
  MORNING_ROUTINE = 'morning_routine',
  EVENING_ROUTINE = 'evening_routine'
}

export enum BEARSONA_PROFILE {
  FOCUS = 'focus',
  CHEERLEADER = 'cheerleader',
  JESTER = 'jester',
  OG = 'og',
  PIRATE = 'pirate',
  SASSY = 'sassy'
}

export enum ONBOARD_FLOW_TIME_UI {
  WAKE_UP = 'wake_up',
  START_STUDY = 'start_study',
  FINISH_STUDY = 'finish_study',
  GO_TO_SLEEP = 'go_to_sleep'
}
